// extracted by mini-css-extract-plugin
module.exports = {"wrap":"General_wrap__5XJxE","widgets":"General_widgets__5ryVe","nonFinancialBenefitsWrap":"General_nonFinancialBenefitsWrap__3Neu0"};